// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"174":"5e82b4aa","605":"c434c9fa","725":"ed8918f3"}[chunkId] + ".chunk.js";
};